import { PipeTransform, Pipe } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Pipe({name: 'plurality'})
export class Plurality implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: Number, translateName: String, includeValue: boolean = true, translateParams: any = null): string {
 
    if(translateName){

      let translateStr = '';
      
      if(value > 1){
        translateStr = this.translate.instant(translateName+'.PLURAL',translateParams);
      }
      else if(value === 1){
        translateStr = this.translate.instant(translateName+'.SINGULAR',translateParams);
      }
      else if(value === 0 || value === -1 || value===null || value===undefined){
        return this.translate.instant(translateName+'.NONE',translateParams);
      }
      
      if(includeValue){
        return value + ' '+translateStr;
      }
      else {
        return translateStr;
      }

    }

  }
}



// WEBPACK FOOTER //
// ./src/pipes/plurality.ts